<template>
  <div class="pendingPopup">
    <el-dialog top="5%" width="1000px" :visible.sync="visiblePending">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="pending-title">Pending Reason<span style="color:red">*</span></div>
        </el-col>
        <el-col :span="8">
          <div class="pending-title">Pending Responsible<span style="color:red">*</span></div>
        </el-col>
        <el-col :span="8">
          <div class="pending-title">Comments</div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="16">
          <el-row :gutter="20" v-for="(item, i) in pendingBody.reason_list" :key="i" style="margin-bottom:10px;">
            <el-col :span="12" style="line-height: 40px;">
              <el-checkbox v-model="item.isDisplay">{{item.type}}</el-checkbox>
            </el-col>
            <el-col :span="12">
              <el-select v-model="item.content" placeholder="Please select the responsible" style="width:100%">
                <el-option v-for="sub in item.contentList" :key="sub" :label="sub" :value="sub">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-input v-model="pendingBody.pending_comments" type="textarea" placeholder="Please input comments.."
                    rows="15" maxlength="2000" style="width: 100%; height: 350px;"></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visiblePending = false">Cancel</el-button>
        <el-button type="primary" @click="savePending">Confirm</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        visiblePending: false,
        pendingBody: {
          item_id: 0,
          reason_list: [],
        },
      }
    },

    methods: {
      show(val) {
        this.pendingBody = {
          item_id: val,
          reason_list: [
            {
              type: "L/D NOT finished",
              contentList: ["PE", "PL", "Supplier"],
              isDisplay: false,
              content: ""
            },
            {
              type: "Digital sample or S/O not validated",
              contentList: ["PE", "PL", "Supplier"],
              isDisplay: false,
              content: ""
            },
            {
              type: "Cylinder or screen sample not validated",
              contentList: ["PE", "PL", "Supplier"],
              isDisplay: false,
              content: ""
            },
            {
              type: "Test result",
              contentList: ["PE", "PL", "Supplier"],
              isDisplay: false,
              content: ""
            },
            {
              type: "sharing doesn't belong to this supplier",
              contentList: ["PE", "PL", "Supplier"],
              isDisplay: false,
              content: ""
            }, {
              type: "Waiting for Confirmation",
              contentList: ["PL", "FG PL", "CPT PL"],
              isDisplay: false,
              content: ""
            }, {
              type: "Model is not validated yet.",
              contentList: ["PL", "FG PL", "CPT PL"],
              isDisplay: false,
              content: ""
            }
          ],
          reason_other: "",
          pending_comments: '',
        };
        this.visiblePending = true;
      },

      // 保存 Pending
      savePending() {
        let formData = new FormData();
        // for (let i = 0; i < this.multipleSelection.length; i++) {
        formData.append(`item_id[0]`, this.pendingBody.item_id);
        // }
        let a = 0;
        for (let i = 0; i < this.pendingBody.reason_list.length; i++) {
          const element = this.pendingBody.reason_list[i];
          if (element.isDisplay) {
            formData.append(`reason_list[${i}][type]`, element.type);
            if (!element.content) {
              a++
            }
            formData.append(`reason_list[${i}][content]`, element.content);
          } else {
            a++
          }
        }

        if (a === this.pendingBody.reason_list.length) {
          this.$notify({
            title: "Warning",
            message: "Please choose the correct 'Reason' and 'Responsible'.",
            type: "warning"
          });
          return;
        }

        if (this.pendingBody.pending_comments) {
          formData.append(`pending_comments`, this.pendingBody.pending_comments);
        }

        this.$api.orderPending(formData).then(res => {
          this.visiblePending = false;
          this.$emit('save');
        });
      },

    }
  }
</script>

<style lang="scss">
  .pending-title {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/pendingPopup.vue